import { Injectable } from '@angular/core';
import { Notification } from '@m4u-angular/base/entities/BaseEntities';

@Injectable()
export class NotificationConfigurationBaseService {

    GetButtons(notification: Notification): any[] {
        return [];
    }
}